<template src="./Home.html"> </template>


<script>
import Header from '@/modules/Header/Header.vue';
import Menu from '@/modules/Menu/Menu.vue';
import MapControl from '@/modules/MapControl/MapControl.vue';
import Map from '@/modules/Map/Map.vue';
import DataAnalysis from '@/modules/DataAnalysis/DataAnalysis.vue';
import Notifications from '@/modules/Notifications/Notifications.vue';
import WeatherStation from '@/modules/WeatherStation/WeatherStation.vue';
// import Legend from '@/modules/Legend/Legend.vue';
import Footer from '@/modules/Footer/Footer.vue';
import Alerts from '@/modules/Alerts/Alerts.vue';

import { mapState, mapActions } from 'vuex';

export default {
    name: 'ViewHome',
    components: {
        Header,
        Menu,
        MapControl,
        Map,
        DataAnalysis,
        Notifications,
        WeatherStation,
        Footer,
        Alerts,
    },
    computed: {
        
        ...mapState({
            mapMode: state => state.mapMode,
            mVar: state => state.menuSettings.variable,
            isShowDataAnalysis: state => state.dataAnalysisStatus,
            isShowDataAnalysisFullScreen: state => state.dataAnalysisFullScreen,

            isShowNotifications: state => state.notifications.viewNotificationsManager,
            isShowViewWeatherStationManager: state => state.ws.viewWeatherStationManager,
        }),

        menuStatus() {
            if (this.isShowDataAnalysis)
                return true;
            return false;
        },

        // mapConfig (state) {
        //     return {...state.menuVariable, ...state.menuPeriod, ...state.menuLocale}
        // },

        dataAnalysisFullScreen: function() {
            return this.isShowDataAnalysisFullScreen;
        },

        isPanelVisible() {
            return this.dataAnalysisStatus || this.isShowNotifications || this.isShowViewWeatherStationManager;
        },

        mapColStyle() {
            if (!this.isPanelVisible) {
                return { flex: '0 0 100%', maxWidth: '100%', width: '100%' };
            }

            if (this.dataAnalysisFullScreen) {
                return {};
            }

            return { flex: '0 0 40%', maxWidth: '40%', width: '40%' };
        },

        dataColStyle() {
            if (!this.isPanelVisible) return {};

            if (this.dataAnalysisFullScreen) {
                return { flex: '0 0 100%', maxWidth: '100%', width: '100%' };
            }

            return { flex: '0 0 60%', maxWidth: '60%', width: '60%' };
        },

        dataAnalysisStatus: function() {
            if (this.mVar.id == '' && this.isShowDataAnalysis) {
                this.newAlert({message: 'Please select a variable to visualize the data!', type: 'error'});
                return false;
            }
            return this.isShowDataAnalysis;
        }
    },
    methods: {
        ...mapActions({
            setAlert: 'setAlert',
            setDataAnalysisFullScreen: 'setDataAnalysisFullScreen'
        }),
    
        newAlert(alert) {
            this.setAlert(alert);
        },

        toggleDataAnalysisFullScreen(nextState = false) {
            this.setDataAnalysisFullScreen(!!nextState);
        }

    },
    data: () => ({
    }),
}
</script>


<style lang="scss" src="./Home.scss"> </style>